export default __webpack_public_path__ + "static/N0293-abd4829ef22cc7f3806410066deb3dff.png";